import React from 'react';
import Avatar from 'src/components/Avatar';
import Tenant from 'src/components/Tenant';
import { CanonicalContact } from '../helpers/contactShape';
import './ContactRow.scss';

interface ContactRowProps {
  contact: CanonicalContact;
  onSelect: (contact: CanonicalContact) => void;
  subtitleVariant: 'role-only' | 'role-and-services';
}

const buildStrapline = (
  contact: CanonicalContact,
  variant: 'role-only' | 'role-and-services'
): string => {
  if (variant === 'role-only') {
    return contact.role;
  }

  if (contact.servicesProvided.length === 0) {
    return contact.role;
  }

  return `${contact.role} - ${contact.servicesProvided.join(', ')}`;
};

const buildAvatarBadge = (
  contact: CanonicalContact
): 'service-provider' | 'property-manager' => {
  if (
    contact.role === 'Service Provider' ||
    contact.role === 'Service Manager'
  ) {
    return 'service-provider';
  }

  return 'property-manager';
};

const ContactRow = ({
  contact,
  onSelect,
  subtitleVariant,
}: ContactRowProps) => {
  const isUnrecognized: boolean = contact.role === 'Unrecognized';
  const rowClassName: string = isUnrecognized
    ? 'contact-row contact-row-unrecognized'
    : 'contact-row';

  return (
    <button
      type="button"
      className={rowClassName}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        onSelect(contact);
      }}
    >
      <Tenant
        headline={contact.fullName}
        strapline={buildStrapline(contact, subtitleVariant)}
        strapLineItemsListRole={contact.role}
        strapLineItemsList={contact.servicesProvided}
        avatar={
          <Avatar
            badge={buildAvatarBadge(contact)}
            url={contact.profileImage}
            size={undefined}
          />
        }
        company={contact.companyName}
      />
    </button>
  );
};

export default ContactRow;
